import React from "react";
import { Layout } from "components/Layout/Layout";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import Grid from "@mui/material/Grid2";
import { TaskListForDashboard } from "./components/TaskList";
import { TaskDashboardProvider } from "./context";
import { Fab, IconButton } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useNavigate } from "react-router-dom";
import { routeLinks } from "constants/paths";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import AddIcon from "@mui/icons-material/Add";
import { useGlobalContext } from "context/GlobalContext";

export const TaskManagementDashboardOld = () => {
  const navigate = useNavigate();
  const { isMobile } = useGlobalContext();
  const handleListIconClick = () => {
    navigate(routeLinks.taskManagementTask);
  };
  return (
    <TaskDashboardProvider>
      <Layout>
        <FlexBox justifyContent="space-between">
          <FlexBox alignItems="center">
            <PageTitle pageName={pageName.dashboard.task} />
            <IconButton onClick={handleListIconClick}>
              <ListAltIcon />
            </IconButton>
          </FlexBox>
          <Fab
            color="primary"
            size="small"
            aria-label="Add"
            onClick={() => navigate(routeLinks.addNewTask)}
          >
            <AddIcon />
          </Fab>
        </FlexBox>
        <ToolbarThinWrapper />
        <Grid container spacing={1}>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={
                isMobile
                  ? pageName.dashboard.mobAssignedToMePendingTask
                  : pageName.dashboard.assignedToMePendingTask
              }
              type="assignedToMePending"
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={
                isMobile
                  ? pageName.dashboard.mobAssignedToMeAcceptedTask
                  : pageName.dashboard.assignedToMeAcceptedTask
              }
              type="assignedToMeAccepted"
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={
                isMobile
                  ? pageName.dashboard.mobAssignedByMePendingTask
                  : pageName.dashboard.assignedByMePendingTask
              }
              type="assignedByMePending"
            />
          </Grid>
          <Grid size={{ md: 6, xs: 12 }}>
            <TaskListForDashboard
              pageName={
                isMobile
                  ? pageName.dashboard.mobAssignedByMeAcceptedTask
                  : pageName.dashboard.assignedByMeAcceptedTask
              }
              type="assignedByMeAccepted"
            />
          </Grid>
        </Grid>
      </Layout>
    </TaskDashboardProvider>
  );
};
